import React from 'react'
import Footer from '../../Footer'
import ImageGallery from 'react-image-gallery';
import '../Proj.css'


const images = [
    {
      original: 'https://i.imgur.com/EIOYQ21.jpg',
      thumbnail: 'https://i.imgur.com/EIOYQ21.jpg',
    },
    {
      original: 'https://i.imgur.com/nSTWr1l.jpg',
      thumbnail: 'https://i.imgur.com/nSTWr1l.jpg',
    },
    {
      original: 'https://i.imgur.com/jly5JQd.jpg',
      thumbnail: 'https://i.imgur.com/jly5JQd.jpg',
    },
    {
        original: 'https://i.imgur.com/xsGkoTY.jpg',
        thumbnail: 'https://i.imgur.com/xsGkoTY.jpg',
    },
    {
    original: 'https://i.imgur.com/5aPBOAk.jpg',
    thumbnail: 'https://i.imgur.com/5aPBOAk.jpg',
    },
    {
    original: 'https://i.imgur.com/OhG0fku.jpg',
    thumbnail: 'https://i.imgur.com/OhG0fku.jpg',
    },
    {
    original: 'https://i.imgur.com/nu6ken9.jpg',
    thumbnail: 'https://i.imgur.com/nu6ken9.jpg',
    },
    {
    original: 'https://i.imgur.com/hnzga3E.jpg',
    thumbnail: 'https://i.imgur.com/hnzga3E.jpg',
    }
];


export default class ProjJapanTravel extends React.Component{
    render(){
        return(
            <div className="proj-wrapper">
                <div className='proj-wrap'>
                    <div id='illust-title'>
                        <h1>Trip to Japan, 2019 Winter</h1>
                        <p className='little-title'>Tokyo, Shizuoka, Kanagawa.</p>
                    </div>
                </div>
                <div className='proj-image-gallery'>
                    <ImageGallery items={images} />
                </div>
                <Footer back={true}/>
            </div>
                
            
        )
    }
}